import { __decorate } from "tslib";
import { Component } from 'decorators';
import view from './instructionsList.view.html';
let InstructionsListComponent = class InstructionsListComponent {
    constructor() {
        this.dropdownRef = [];
    }
    handleCreateInstruction(role) {
        this.onCreateInstruction?.({ role });
        this.closeDropdown();
    }
    handleDeletePrompt(promptId) {
        this.onDeletePrompt?.({ promptId });
    }
    handleCopyPrompt(promptId) {
        this.onCopyPrompt?.({ promptId });
    }
    handleSavePrompt(instruction) {
        this.onSavePrompt?.({ instruction });
    }
    handleOpenModelAdjustment() {
        this.onOpenModelAdjustmentModal?.();
    }
    handleGenerateInstructions() {
        this.onGenerateInstructions?.();
    }
    handleOptimizeInstructions() {
        this.onOptimizeInstructions?.();
        this.closeDropdown();
    }
    handleOpenGuardrailModal() {
        this.onOpenGuardrailModal?.();
    }
    closeDropdown() {
        if (this.dropdownRef?.length > 0 && this.dropdownRef[0]) {
            this.dropdownRef[0].setClose?.();
        }
    }
};
InstructionsListComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: view,
        bindings: {
            selectedModel: '<',
            instructions: '<',
            promptRoles: '<',
            roleIconMap: '<',
            ngSortableOptions: '<',
            isPromptOptimizationEnabled: '<',
            onOpenModelAdjustmentModal: '&?',
            onCreateInstruction: '&?',
            onGenerateInstructions: '&?',
            onOptimizeInstructions: '&?',
            onDeletePrompt: '&?',
            onCopyPrompt: '&?',
            onSavePrompt: '&?',
            onOpenGuardrailModal: '&?',
            stateId: '<',
        },
    })
], InstructionsListComponent);
export { InstructionsListComponent };
